import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-primary-500" />
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-1">
              {subtitle}
            </p>
          )}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap flex items-center gap-1 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line" />
        </Link>
      )}
    </div>
  );
}